import * as Route from '../support/serverRoutes';
import makeRequest from '../../main/utils/makeRequest';

const tenants = {
  state: {
    data: [],
    meta: null,
    loading: false,
  },
  reducers: {
    setData(state, { data, meta }) {
      return { ...state, data, meta };
    },
    setLoading(state, isLoading) {
      return { ...state, loading: isLoading };
    },
    addItem(state, { name, tenantUuid }) {
      return {
        ...state,
        data: [
          ...state.data,
          {
            name,
            uuid: tenantUuid,
          },
        ],
      };
    },
    deleteItem(state, { tenantUuid }) {
      return {
        ...state,
        data: state.data.filter((e) => {
          return e !== tenantUuid;
        }),
      };
    },
  },
  effects: (dispatch) => ({
    fetchTenantsByEstablishmentId({ establishmentId }) {
      dispatch.tenants.setLoading(true);
      makeRequest({
        dispatch,
        url: Route.getTenantsByEstablishmentId(establishmentId),
        success: (response) => {
          dispatch.tenants.setData({
            data: response.data.data,
            meta: response.data.meta,
          });
        },
        finish: () => {
          dispatch.tenants.setLoading(false);
        },
      });
    },
    addTenant({ name, tenantUuid }) {
      dispatch.tenants.addItem({ name, tenantUuid });
    },
    removeTenant({ tenantUuid }) {
      dispatch.tenants.deleteItem({ tenantUuid });
    },
  }),
};

export default tenants;
